<template>
  <Breadcrumb :items="breadcrumbItems" />


  <div id="perfil-containder">
    <div class="perfil-body">
      <!-- Cabeçalho do perfil -->
      <div class="perfil-header">
        <!-- Input file oculto -->
        <input ref="inputImagem" type="file" accept="image/*" style="display: none" @change="processarImagem" />

        <!-- Imagem clicável -->
        <div class="img-perfil" :class="{ editavel: modoEditar }" @click="abrirSeletorImagem()">
          <img v-if="imagemPreview" :src="imagemPreview" alt="Foto de perfil" />
          <img v-else-if="userData.imagemUrl" :src="userData.imagemUrl" alt="Foto de perfil" />
          <img v-else src="@/assets/ix_user-profile-filled.png" alt="Foto de perfil" />
          <div v-if="modoEditar" class="icone-editar-foto">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
              <circle cx="12" cy="13" r="4" />
            </svg>
          </div>

          <button v-if="modoEditar && (imagemPreview || userData.imagemUrl)" class="btn-remover-foto"
            @click.stop="removerImagem()" title="Remover foto">
            Remover Foto
          </button>
        </div>

        <div class="nome">
          <div class="nome-email">
            <h2>{{ nome }}</h2>
            <p>{{ email }}</p>
          </div>
          <div class="nacionalidade">
            <p>{{ nacionalidade }}</p>
          </div>
          <div id="edicao-credenciais">
            <button class="btn-editar-credencial" :disabled="carregando" @click="toggleMudarEmail = true">
              Alterar Email
            </button>
            <button class="btn-editar-credencial" :disabled="carregando" @click="mudarSenha">
              Alterar Senha
            </button>
            <!-- Botões -->
            <div class="acoes-botoes">
              <button v-if="!modoEditar" :disabled="carregando" class="btn-editar" @click="ativarEdicao">
                Editar
              </button>
              <template v-else>
                <button class="btn-salvar" @click="salvarEdicao()">
                  Salvar
                </button>
                <button class="btn-cancelar" @click="cancelarEdicao">
                  Cancelar
                </button>
              </template>
            </div>
          </div>
        </div>
      </div>
      <!-- Solicitação de alteração cadastral -->

      <!-- Solicitação de alteração cadastral -->
      <section v-if="modoEditar" class="solicitacao-cadastral">
        <div class="solicitacao-cadastral-info">
          <i class="ti ti-info-circle" aria-hidden="true"></i>

          <div>
            <h4>Atenção</h4>
            <p>
              Os dados pessoais como Nome, CPF e Data de Nascimento só podem ser alterados mediantes
              solicitação à
              PREX. Para isso é preciso fazer o envio de documentação comprobatória como Identidade ou CNH.
            </p>
          </div>
        </div>

        <div class="menu-email" ref="menuEmailRef">
          <button type="button" class="btn-solicitar-alteracao" aria-haspopup="true" :aria-expanded="menuEmailAberto"
            @click="menuEmailAberto = !menuEmailAberto">
            Solicitar alteração cadastral
            <i class="ti ti-chevron-down" aria-hidden="true"></i>
          </button>

          <ul v-if="menuEmailAberto" class="menu-email-opcoes" role="menu">
            <li role="none">
              <a role="menuitem" :href="linksEmail.outlook" target="_blank" rel="noopener noreferrer"
                @click="menuEmailAberto = false">Outlook / Hotmail</a>
            </li>
            <li role="none">
              <a role="menuitem" :href="linksEmail.gmail" target="_blank" rel="noopener noreferrer"
                @click="menuEmailAberto = false">Gmail</a>
            </li>
            <li role="none">
              <a role="menuitem" :href="linksEmail.padrao" @click="menuEmailAberto = false">
                Aplicativo de e-mail padrão
              </a>
            </li>
          </ul>
        </div>
      </section>



      <!-- Informações pessoais -->
      <div class="informacoes-perfil">
        <h3>INFORMAÇÕES PESSOAIS</h3>
        <Carregamento v-if="carregando" />
        <div class="campos-infos" v-else>
          <!-- CPF (sempre desabilitado) -->
          <div class="mb-3">
            <label class="form-label">CPF</label>
            <input type="text" class="form-control" v-model="userData.cpf" disabled />
          </div>
          <!-- Data de Nascimento -->
          <div class="mb-3">
            <label class="form-label">Data de nascimento</label>
            <input type="date" class="form-control" :class="{ 'input-invalido': erros.dataNascimento }"
              v-model="userData.dataNascimento" :disabled="!modoEditar || temDataNascimentoCadastrada" :max="hoje"
              @change="validarDataNascimento" />
            <span v-if="erros.dataNascimento" class="msg-erro">Formato inválido!</span>
          </div>
          <!-- Telefone -->
          <div class="mb-3">
            <label class="form-label">Telefone</label>
            <input type="tel" class="form-control" :class="{ 'input-invalido': erros.telefone }"
              v-model="userData.telefone" :disabled="!modoEditar" maxlength="19" placeholder="+55 (00) 00000-0000"
              v-maska="'+## (##) 9####-####'" @blur="validarTelefone" />
            <span v-if="erros.telefone" class="msg-erro">Formato inválido!</span>
          </div>
          <!-- Gênero -->
          <div class="mb-3">
            <label class="form-label">Gênero</label>
            <select class="form-control" v-model="userData.genero" :disabled="!modoEditar">
              <option value="">Não informado</option>
              <option v-for="item in genero" :key="item.valor" :value="item.valor">
                {{ item.nome }}
              </option>
            </select>
          </div>

          <!-- Heteroidentificação -->
          <div class="mb-3">
            <label class="form-label">Heteroidentificação</label>
            <select class="form-control" v-model="userData.heteroidentificacao" :disabled="!modoEditar">
              <option v-for="item in heteroidentificacao" :key="item.valor" :value="item.valor">
                {{ item.nome }}
              </option>
            </select>
          </div>

          <!-- Escolaridade -->
          <div class="mb-3">
            <label class="form-label">Escolaridade</label>
            <select class="form-control" v-model="userData.escolaridade" :disabled="!modoEditar">
              <option value="">Não informado</option>
              <option v-for="item in escolaridade" :key="item.valor" :value="item.valor">
                {{ item.nome }}
              </option>
            </select>
          </div>

          <!-- Renda Familiar -->
          <div class="mb-3">
            <label class="form-label">Renda familiar</label>
            <select class="form-control" v-model="userData.rendaFamiliar" :disabled="!modoEditar">
              <option value="">Não informado</option>
              <option v-for="item in rendaFamiliar" :key="item.valor" :value="item.valor">
                {{ item.nome }}
              </option>
            </select>
          </div>

          <!-- Zona de Moradia -->
          <div class="mb-3">
            <label class="form-label">Zona de moradia</label>
            <select class="form-control" v-model="userData.zonaMoradia" :disabled="!modoEditar">
              <option value="">Não informado</option>
              <option v-for="item in zonaMoradia" :key="item.valor" :value="item.valor">
                {{ item.nome }}
              </option>
            </select>
          </div>

          <!-- Unidade de Origem (Somente SIGAA) -->
          <div class="mb-3" v-if="isSigaaUser">
            <label class="form-label">Unidade de origem</label>
            <select class="form-control" v-model="userData.unidadeId" :disabled="!modoEditar">
              <option value="">Selecione uma unidade...</option>
              <option v-for="item in unidadesDaUfc" :key="item.id" :value="item.id">
                {{ item.nome }}
              </option>
            </select>
          </div>
        </div>
      </div>



      <!-- Documentos e Condições de Uso -->
      <div class="documentos-condicoes-perfil">
        <h3>DOCUMENTOS E CONDIÇÕES DE USO</h3>

        <div class="docs-condicoes-card">
          <!-- Termo de Uso -->
          <div class="doc-item-linha">
            <div class="doc-item-dados">
              <div class="doc-icone-svg">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                  <polyline points="14 2 14 8 20 8" />
                  <line x1="16" y1="13" x2="8" y2="13" />
                  <line x1="16" y1="17" x2="8" y2="17" />
                  <polyline points="10 9 9 9 8 9" />
                </svg>
              </div>
              <div class="doc-item-textos">
                <h4>Termo de Uso do GEX</h4>
                <p>Regras de utilização, responsabilidades e condições de acesso.</p>
              </div>
            </div>
            <a v-if="termoVigente?.termoUsoUrl" :href="termoVigente.termoUsoUrl" target="_blank"
              rel="noopener noreferrer" class="link-consultar-doc">
              Consultar documento
            </a>
            <span v-else class="link-consultar-doc disabled">
              Consultar documento
            </span>
          </div>

          <!-- Política de Privacidade -->
          <div class="doc-item-linha">
            <div class="doc-item-dados">
              <div class="doc-icone-svg">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                  <polyline points="9 12 11 14 15 10" />
                </svg>
              </div>
              <div class="doc-item-textos">
                <h4>Política de Privacidade</h4>
                <p>Dados pessoais, finalidades do tratamento e direitos dos titulares.</p>
              </div>
            </div>
            <a v-if="termoVigente?.politicaPrivacidadeUrl" :href="termoVigente.politicaPrivacidadeUrl" target="_blank"
              rel="noopener noreferrer" class="link-consultar-doc">
              Consultar documento
            </a>
            <span v-else class="link-consultar-doc disabled">
              Consultar documento
            </span>
          </div>


          <!-- Concordância com o Termo de Uso -->
          <div class="concordancia-secao">
            <h4 class="concordancia-subtitulo">Concordância com o Termo de Uso</h4>
            <div class="versao-rotulo">
              Versão {{ versaoExibida }}
            </div>

            <div class="concordancia-linha-status">
              <div class="concordancia-descricoes">
                <p class="concordancia-declaracao">
                  Li e concordo com o Termo de Uso do GEX.
                </p>
                <p class="concordancia-aviso">
                  Você pode consultar o documento completo a qualquer momento.
                </p>
                <small v-if="termoConcordado && termoDataConcordanciaFormatada" class="concordancia-registro-data">
                  Concordância registrada em {{ termoDataConcordanciaFormatada }}
                </small>
              </div>

              <!-- Checkbox interativo de concordância -->
              <div class="concordancia-acao-status">
                <label class="custom-checkbox-perfil"
                  :title="termoConcordado ? 'Clique para desmarcar os Termos de Uso' : 'Clique para concordar com os Termos de Uso'">
                  <input type="checkbox" :checked="termoConcordado" @click.prevent="aoClicarCheckboxTermo"
                    :disabled="concordandoPeloPerfil || processandoRevogacaoTermo" />
                  <span class="checkmark-perfil">
                    <span v-if="concordandoPeloPerfil || processandoRevogacaoTermo"
                      class="spinner-border spinner-border-sm spinner-checkbox-perfil"></span>
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Minhas Ações -->
      <div class="acoes-perfil">
        <h3>MINHAS AÇÕES</h3>

        <Carregamento v-if="carregando" />

        <template v-else-if="acoesOrdenadas.length > 0">
          <div class="grid-acoes-perfil">
            <div v-for="acao in acoesPaginadas" :key="acao.acao_id || acao.id" class="conteudo"
              @click="abrirAcao(acao.acao_id || acao.id)" @keyup.enter="abrirAcao(acao.acao_id || acao.id)" tabindex="0"
              role="button" aria-label="Abrir detalhes da ação">
              <div class="imagem-conteudo-acao">
                <img v-if="acao.imagemUrl" :src="acao.imagemUrl" :alt="`Imagem da ação ${acao.titulo || ''}`"
                  loading="lazy" decoding="async" @error="(event) => {
                    event.target.style.display = 'none';
                    event.target.nextElementSibling.style.display = 'block';
                  }" />

                <img src="@/assets/logoGex1.2.png" alt="Logo GEX" loading="lazy" decoding="async"
                  class="imagem-fallback" :style="{ display: acao.imagemUrl ? 'none' : 'block' }" />
              </div>

              <div class="conteudo-listagem-acao">
                <div class="cima-conteudo-acao">
                  <h5 class="titulo-acao">
                    {{ acao.titulo || "Sem título" }}
                  </h5>

                  <span v-if="
                    acao.dataInicio ||
                    acao.dataFim ||
                    acao.acao_data_inicio ||
                    acao.acao_data_fim
                  " class="periodo-acao">
                    Período: {{ formatarPeriodoAcao(acao) }}
                  </span>
                </div>

                <div class="baixo-conteudo-acao">
                  <p class="area-tematica">
                    <b>Área Temática: </b>
                    {{ acao.areaTematica || acao.area_tematica || "Não informada" }}
                  </p>

                  <p class="funcao-membro">
                    <b>Tipo de membro: </b>
                    {{ acao.funcao_membro || acao.funcaoMembro || "Participante" }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!-- Paginação -->
          <PaginacaoComponent v-if="totalPaginasAcoes > 1" :totalPaginas="totalPaginasAcoes"
            :paginaAtual="paginaAtualAcoes" :rolarParaTopo="false" @mudar-pagina="mudarPaginaAcoes" />
        </template>

        <div v-else class="sem-acoes">
          <p>Nenhuma ação vinculada ao seu perfil foi encontrada.</p>
        </div>
      </div>



    </div>
  </div>

  <div class="overlay" v-if="toggleMudarEmail">
    <div class="modal-email">
      <div class="modal-header">
        <span class="modal-label">Alterar email</span>
        <button class="btn-fechar-modal" @click.prevent="toggleMudarEmail = false">
          ×
        </button>
      </div>
      <form class="modal-corpo" @submit.prevent="mudarEmail">
        <div class="campos-form-container">
          <div class="campos-form">
            <div class="mb-3">
              <div class="label-container">
                <label for="email" class="form-label">Novo email*</label>
              </div>
              <input type="email" id="nome" class="form-control fm" v-model="novoEmail" required />
            </div>
          </div>
          <div id="modal-rodape" style="display: flex; align-items: center; justify-content: center; margin-top: 1rem;">
            <button id="enviar" type="submit" class="btn-confirmar">
              Confirmar
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <!-- Modal de Confirmação para Desmarcar Termos de Uso -->
  <div class="overlay" v-if="modalDesmarcarTermoAberto" @click.self="fecharModalDesmarcarTermo">
    <div class="modal-confirmacao-termo" role="dialog" aria-modal="true" aria-labelledby="modal-termo-titulo">
      <div class="modal-header">
        <span id="modal-termo-titulo" class="modal-label">Atenção</span>
        <button type="button" class="btn-fechar-modal" @click="fecharModalDesmarcarTermo"
          :disabled="processandoRevogacaoTermo" aria-label="Fechar">
          ×
        </button>
      </div>

      <div class="modal-corpo modal-corpo-aviso-termo">
        <div class="icone-alerta-termo" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
        </div>
        <p class="texto-aviso-desmarcar">
          <strong>ATENÇÃO:</strong> A não aceitação dos Termos de Uso impedirá seu acesso ao Sistema de Gestão da
          Extensão
          (GEX). Deseja continuar sem aceitar os Termos de Uso?
        </p>
      </div>

      <div class="modal-rodape modal-rodape-termo">
        <button type="button" class="btn-cancelar-termo" @click="fecharModalDesmarcarTermo"
          :disabled="processandoRevogacaoTermo">
          Cancelar
        </button>
        <button type="button" class="btn-continuar-sem-aceitar" @click="confirmarDesmarcarTermo"
          :disabled="processandoRevogacaoTermo">
          <span v-if="processandoRevogacaoTermo" class="spinner-border spinner-border-sm me-2" role="status"
            aria-hidden="true"></span>
          {{ processandoRevogacaoTermo ? "Revogando..." : "Continuar sem aceitar" }}
        </button>
      </div>
    </div>
  </div>

  <!-- Modal de aviso -->
  <Aviso :sucesso="sucesso" :texto="texto" @fecharModal="fecharAviso" v-if="aviso" />
</template>

<script setup>
import usuariosService from "@/service/usuariosService";
import termoService from "@/service/termoService";
import unidadesService from "@/service/unidadesService";
import PaginacaoComponent from "@/components/common/paginacaoComponent.vue";
import { useAuthStore } from "@/stores/auth";
import { ref, onMounted, onBeforeUnmount, computed } from "vue";
import { jwtDecode } from "jwt-decode";
import { formatarCPF, formatarData } from "@/utils/FormatarEntradas";
import router from "@/router";
import { vMaska } from "maska/vue";
import Aviso from "@/components/common/aviso.vue";
import Carregamento from "@/components/common/Carregamento.vue";
import Breadcrumb from "@/components/common/Breadcrumb.vue";

const auth = useAuthStore();
const termoVigente = ref(null);
const termoConcordado = ref(false);
const termoVersaoConcordada = ref("");
const termoDataConcordancia = ref(null);
const concordandoPeloPerfil = ref(false);
const modalDesmarcarTermoAberto = ref(false);
const processandoRevogacaoTermo = ref(false);

const versaoExibida = computed(() => {
  return termoVersaoConcordada.value || termoVigente.value?.versao || "1.0";
});

const termoDataConcordanciaFormatada = computed(() => {
  if (!termoDataConcordancia.value) return "";
  try {
    const data = new Date(termoDataConcordancia.value);
    return data.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return termoDataConcordancia.value;
  }
});

async function carregarTermosUsuario() {
  try {
    const vigente = await termoService.obterTermoVigente();
    termoVigente.value = vigente;
    if (vigente) {
      if (vigente.usuarioConcordou !== undefined && vigente.usuarioConcordou !== null) {
        termoConcordado.value = Boolean(vigente.usuarioConcordou);
      }
      if (vigente.usuarioVersaoConcordada) {
        termoVersaoConcordada.value = vigente.usuarioVersaoConcordada;
      }
      if (vigente.usuarioDataConcordancia) {
        termoDataConcordancia.value = vigente.usuarioDataConcordancia;
      }
    }
  } catch (err) {
    console.error("Erro ao carregar dados de termos no perfil:", err);
  }
}

async function concordarPeloPerfil() {
  concordandoPeloPerfil.value = true;
  try {
    const versao = termoVigente.value?.versao || null;
    const res = await termoService.registrarConcordancia(true, versao);
    termoConcordado.value = true;
    termoVersaoConcordada.value = versao;
    termoDataConcordancia.value = res?.dataConcordancia || new Date().toISOString();
    auth.definirStatusTermo(false, {
      ...termoVigente.value,
      usuarioConcordou: true,
      usuarioVersaoConcordada: versao,
      usuarioDataConcordancia: termoDataConcordancia.value,
      precisaConcordar: false,
    });
  } catch (err) {
    console.error("Erro ao registrar concordância pelo perfil:", err);
    texto.value = "Ocorreu um erro ao registrar a concordância. Tente novamente.";
    sucesso.value = false;
    aviso.value = true;
  } finally {
    concordandoPeloPerfil.value = false;
  }
}

function aoClicarCheckboxTermo() {
  if (concordandoPeloPerfil.value || processandoRevogacaoTermo.value) return;

  if (termoConcordado.value) {
    modalDesmarcarTermoAberto.value = true;
  } else {
    concordarPeloPerfil();
  }
}

function fecharModalDesmarcarTermo() {
  if (processandoRevogacaoTermo.value) return;
  modalDesmarcarTermoAberto.value = false;
}

async function confirmarDesmarcarTermo() {
  processandoRevogacaoTermo.value = true;
  try {
    const versao = termoVersaoConcordada.value || termoVigente.value?.versao || null;
    await termoService.registrarConcordancia(false, versao);
    termoConcordado.value = false;
    termoDataConcordancia.value = null;
    auth.finalizarSessao();
    modalDesmarcarTermoAberto.value = false;
    router.push("/");
  } catch (err) {
    console.error("Erro ao revogar aceite do termo:", err);
    texto.value = "Ocorreu um erro ao revogar a concordância com o termo. Tente novamente.";
    sucesso.value = false;
    aviso.value = true;
  } finally {
    processandoRevogacaoTermo.value = false;
  }
}

const nome = ref("");
const email = ref("");
const nacionalidade = ref("");
const modoEditar = ref(false);
const toggleMudarEmail = ref(false);
const novoEmail = ref("");
const verificacaoNumero = ref(false);
const dataNascimentoOriginal = ref("");
const temDataNascimentoCadastrada = computed(() => Boolean(dataNascimentoOriginal.value && dataNascimentoOriginal.value.trim()));
const isSigaaUser = ref(false);
const unidadesDaUfc = ref([]);

let snapshot = {};
let snapshotImagem = { preview: null, base64: null, mimeType: null };

const carregando = ref(false);

const hoje = new Date().toISOString().split("T")[0];

const aviso = ref(false);
const sucesso = ref(false);
const texto = ref("");


const emailPrex = "prex.gabinete@gmail.com";

const assuntoSolicitacao =
  "Solicitação de alteração de dados cadastrais — Sistema de Extensão";

const menuEmailAberto = ref(false);
const menuEmailRef = ref(null);

const mensagemSolicitacao = computed(() => {
  const nomeCadastrado = nome.value?.trim() || "[preencher]";


  return [
    "Prezada equipe da PREX,",
    "",
    "Gostaria de solicitar a análise e a correção de dados cadastrais vinculados ao meu registro no Sistema de Extensão.",
    "",
    "Nome completo atualmente cadastrado no sistema:",
    `${nomeCadastrado}`,
    "",
    "1. Nome completo",
    "Nome completo correto que desejo cadastrar: [Preencher, se aplicável]",
    "",
    "2. CPF",
    "CPF atualmente cadastrado no sistema: [Preencher, se aplicável]",
    "CPF correto que desejo cadastrar: [Preencher, se aplicável]",
    "",
    "3. Data de nascimento",
    "Data de nascimento atualmente cadastrada no sistema: [DD/MM/AAAA, se aplicável]",
    "Data de nascimento correta que desejo cadastrar: [DD/MM/AAAA, se aplicável]",
    "",
    "Justificativa da solicitação:",
    "[Descreva o motivo da correção]",
    "",
    "Observação: preencha apenas os campos referentes aos dados que deseja corrigir. Os demais podem permanecer em branco.",
    "",
    "Estou à disposição para fornecer informações adicionais ou documentos comprobatórios necessários para a análise da solicitação.",
    "",
  ].join("\n");
});

const linksEmail = computed(() => {
  const para = encodeURIComponent(emailPrex);
  const assunto = encodeURIComponent(assuntoSolicitacao);
  const corpo = encodeURIComponent(mensagemSolicitacao.value);
  const corpoMailto = encodeURIComponent(
    mensagemSolicitacao.value.replace(/\n/g, "\r\n")
  );

  return {
    outlook: `https://outlook.live.com/mail/0/deeplink/compose?to=${para}&subject=${assunto}&body=${corpo}`,
    gmail: `https://mail.google.com/mail/?view=cm&fs=1&to=${para}&su=${assunto}&body=${corpo}`,
    padrao: `mailto:${emailPrex}?subject=${assunto}&body=${corpoMailto}`,
  };
});

function fecharMenuEmail(event) {
  if (menuEmailRef.value && !menuEmailRef.value.contains(event.target)) {
    menuEmailAberto.value = false;
  }
}

const breadcrumbItems = computed(() => {
  return [
    { label: "Início", to: "/" },
    { label: "Perfil", to: "/perfil" },
  ];
});

function fecharAviso() {
  aviso.value = false;
  if (sucesso.value) {
    window.location.reload();
  }
}

const inputImagem = ref(null);
const imagemPreview = ref(null);
const imagemBase64 = ref(null);
const imagemMimeType = ref(null);

function abrirSeletorImagem() {
  if (modoEditar.value) inputImagem.value.click();
}

function processarImagem(event) {
  const file = event.target.files[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = () => {
    imagemPreview.value = reader.result;
    imagemMimeType.value = file.type;
    imagemBase64.value = reader.result.split(",")[1];
  };
  reader.onerror = () => {
    texto.value = "Erro ao processar a imagem.";
    sucesso.value = false;
    aviso.value = true;
  };
  reader.readAsDataURL(file);
}

const erros = ref({
  telefone: "",
  dataNascimento: "",
});

const userData = ref({
  telefone: "",
  cpf: "",
  genero: "",
  heteroidentificacao: "",
  dataNascimento: "",
  escolaridade: "",
  rendaFamiliar: "",
  zonaMoradia: "",
  unidadeId: "",
});

const heteroidentificacao = [
  { nome: "Não informado", valor: "INDEFINIDO" },
  { nome: "Pardo", valor: "PARDO" },
  { nome: "Branco", valor: "BRANCO" },
  { nome: "Negro", valor: "NEGRO" },
  { nome: "Indígena", valor: "INDIGENA" },
  { nome: "Amarelo", valor: "AMARELO" },
  { nome: "Prefiro não responder", valor: "PREFIRO_NAO_RESPONDE" },
];

const rendaFamiliar = [
  { nome: "Menos de 1 salário mínimo", valor: "MENOS_DE_1_SALARIO_MINIMO" },
  { nome: "De 1 a 3 salários mínimos", valor: "DE_1_A_3_SALARIOS_MINIMOS" },
  { nome: "De 4 a 7 salários mínimos", valor: "DE_4_A_7_SALARIOS_MINIMOS" },
  { nome: "Mais de 7 salários mínimos", valor: "MAIS_DE_7_SALARIOS_MINIMOS" },
  { nome: "Prefiro não responder", valor: "PREFIRO_NAO_RESPONDER" },
];

const genero = [
  { nome: "Homem cisgênero", valor: "HOMEM_CISGENERO" },
  { nome: "Homem transgênero", valor: "HOMEM_TRANSGENERO" },
  { nome: "Mulher cisgênero", valor: "MULHER_CISGENERO" },
  { nome: "Mulher transgênero", valor: "MULHER_TRANSGENERO" },
  { nome: "Gênero não-binário", valor: "GENERO_NAO_BINARIO" },
  { nome: "Agênero", valor: "AGENERO" },
  { nome: "Gênero-fluido", valor: "GENERO_FLUIDO" },
  { nome: "Bigênero", valor: "BIGENERO" },
  { nome: "Mulher transexual", valor: "MULHER_TRANSEXUAL" },
  { nome: "Homem transexual", valor: "HOMEM_TRANSEXUAL" },
  { nome: "Poligênero", valor: "POLIGENERO" },
  { nome: "Gênero neutro", valor: "GENERO_NEUTRO" },
  { nome: "Outro", valor: "OUTRO" },
  { nome: "Prefiro não responder", valor: "PREFIRO_NAO_RESPONDER" },
];

const escolaridade = [
  { nome: "Não alfabetizado", valor: "NAO_ALFABETIZADO" },
  {
    nome: "Ensino fundamental incompleto",
    valor: "ENSINO_FUNDAMENTAL_INCOMPLETO",
  },
  { nome: "Ensino fundamental completo", valor: "ENSINO_FUNDAMENTAL_COMPLETO" },
  { nome: "Ensino médio incompleto", valor: "ENSINO_MEDIO_INCOMPLETO" },
  { nome: "Ensino médio completo", valor: "ENSINO_MEDIO_COMPLETO" },
  { nome: "Ensino superior incompleto", valor: "ENSINO_SUPERIOR_INCOMPLETO" },
  { nome: "Ensino superior completo", valor: "ENSINO_SUPERIOR_COMPLETO" },
  { nome: "Prefiro não responder", valor: "PREFIRO_NAO_RESPONDER" },
];

const zonaMoradia = [
  { nome: "Zona Urbana", valor: "ZONA_URBANA" },
  { nome: "Zona Rural", valor: "ZONA_RURAL" },
  { nome: "Zona Periurbana", valor: "ZONA_PERIURBANA" },
  { nome: "Comunidades", valor: "COMUNIDADES" },
];
const acoes = ref([]);

const acoesOrdenadas = computed(() => {
  const obterAno = (acao) => {
    const data =
      acao.acao_data_inicio ||
      acao.dataInicio ||
      acao.data_inicio ||
      acao.inicio_periodo ||
      acao.inicioPeriodo ||
      acao.acao_data_fim ||
      acao.dataFim ||
      acao.data_fim;

    if (!data) return 0;

    const ano = Number(String(data).slice(0, 4));
    return Number.isFinite(ano) ? ano : 0;
  };

  return [...acoes.value].sort((a, b) => {
    const tituloA = (a.titulo || "").trim();
    const tituloB = (b.titulo || "").trim();

    const comparacaoTitulo = tituloA.localeCompare(
      tituloB,
      "pt-BR",
      { sensitivity: "base" }
    );

    if (comparacaoTitulo !== 0) {
      return comparacaoTitulo;
    }

    return obterAno(b) - obterAno(a);
  });
});
const paginaAtualAcoes = ref(0);
const itensPorPaginaAcoes = 3;

const totalPaginasAcoes = computed(() =>
  Math.ceil(acoesOrdenadas.value.length / itensPorPaginaAcoes)
);

const acoesPaginadas = computed(() => {
  const inicio = paginaAtualAcoes.value * itensPorPaginaAcoes;
  const fim = inicio + itensPorPaginaAcoes;

  return acoesOrdenadas.value.slice(inicio, fim);
});

function mudarPaginaAcoes(novaPagina) {
  if (
    novaPagina < 0 ||
    novaPagina >= totalPaginasAcoes.value
  ) {
    return;
  }

  paginaAtualAcoes.value = novaPagina;
}



function validarTelefone() {
  const raw = userData.value.telefone.replace(/\D/g, "");
  if (userData.value.telefone && raw.length < 13) {
    erros.value.telefone = true;
    return false;
  }
  erros.value.telefone = false;
  return true;
}

function validarDataNascimento() {
  const data = userData.value.dataNascimento;
  if (data && data > hoje) {
    erros.value.dataNascimento = true;
    return false;
  }
  erros.value.dataNascimento = false;
  return true;
}

async function coletarInformacoes() {
  const response = await usuariosService.getUsuarioLogado();

  nome.value = jwtDecode(window.localStorage.getItem("auth_token")).nome;
  email.value = response.email ?? "Indefinido";
  nacionalidade.value = response.estrangeiro ? "Estrangeiro" : "Brasileiro";

  userData.value.cpf = response.cpf ? formatarCPF(response.cpf) : "Indefinido";
  userData.value.telefone = response.telefone ?? "";
  userData.value.genero = response.genero ?? "";
  userData.value.heteroidentificacao = response.heteroidentificacao ?? "";
  userData.value.dataNascimento = response.dataNascimento ?? "";
  dataNascimentoOriginal.value = response.dataNascimento ?? "";
  userData.value.escolaridade = response.escolaridade ?? "";
  userData.value.rendaFamiliar = response.rendaFamiliar ?? "";
  userData.value.zonaMoradia = response.zonaMoradia ?? "";
  userData.value.imagemUrl = response.imagemUrl;
  if (response.termoConcordado !== undefined) {
    termoConcordado.value = Boolean(response.termoConcordado);
  }
  if (response.termoVersaoConcordada) {
    termoVersaoConcordada.value = response.termoVersaoConcordada;
  }
  if (response.termoDataConcordancia) {
    termoDataConcordancia.value = response.termoDataConcordancia;
  }

  // Pegando a unidade do usuário, se vier "unidade" ou "unidadeId" do back
  userData.value.unidadeId =
    response.unidadeId || (response.unidade && response.unidade.id) || "";

  if (response.imagem?.base64Data) {
    imagemPreview.value = `data:${response.imagem.mimeType};base64,${response.imagem.base64Data}`;
    imagemBase64.value = response.imagem.base64Data;
    imagemMimeType.value = response.imagem.mimeType;
  }

  if (response.telefone === "") {
    verificacaoNumero.value = true;
  }

  const authSigaa = window.localStorage.getItem("autenticadoSigaa");
  if (authSigaa === "autenticado") {
    isSigaaUser.value = true;
    try {
      unidadesDaUfc.value = await unidadesService.getAllUnidades(0, 1000);
    } catch (e) {
      console.error("Erro ao buscar unidades", e);
    }
  }
}

async function coletarAcoesVinculadas() {
  const response = await usuariosService.getAcoesUsuario();

  acoes.value = response;
  paginaAtualAcoes.value = 0;
}

function formatarPeriodoAcao(acao) {
  if (!acao) return "Não informado";

  const inicio =
    acao.dataInicio ||
    acao.acao_data_inicio ||
    acao.data_inicio ||
    acao.inicio_periodo ||
    acao.inicioPeriodo;

  const fim =
    acao.dataFim ||
    acao.acao_data_fim ||
    acao.data_fim ||
    acao.fim_periodo ||
    acao.fimPeriodo;

  if (inicio && fim) {
    return `${formatarData(inicio)} até ${formatarData(fim)}`;
  }

  if (inicio) return formatarData(inicio);
  if (fim) return `Até ${formatarData(fim)}`;

  return "Não informado";
}


function ativarEdicao() {
  menuEmailAberto.value = false;
  snapshot = { ...userData.value };
  snapshotImagem = {
    preview: imagemPreview.value,
    base64: imagemBase64.value,
    mimeType: imagemMimeType.value,
  };
  modoEditar.value = true;
}

function cancelarEdicao() {
  userData.value = { ...snapshot };
  imagemPreview.value = snapshotImagem.preview;
  imagemBase64.value = snapshotImagem.base64;
  imagemMimeType.value = snapshotImagem.mimeType;
  erros.value.telefone = false;
  erros.value.dataNascimento = false;
  modoEditar.value = false;
}

async function salvarEdicao() {
  const telefoneOk = validarTelefone();
  const dataOk = validarDataNascimento();
  if (!telefoneOk || !dataOk) return;

  try {
    let payload = {};
    Object.entries(userData.value).forEach(([key, value]) => {
      if (userData.value[key] !== snapshot[key]) {
        payload[key] = value;

        if (key === "telefone") {
          payload[key] = value
            .replace(/[^\d+]/g, "")
            .replace(/(\+\d{2})(\d{2})(\d{5})(\d{4})/, "$1$2$3-$4");
        }

        if (key === "imagem" && userData.value[key] === null) {
          payload.removerImagem = true;
        }
      }
    });

    if (imagemBase64.value) {
      payload.imagem = {
        mimeType: imagemMimeType.value,
        base64Data: imagemBase64.value,
      };
    }

    if (Object.keys(payload).length > 0) {
      await usuariosService.editarPerfilUsuarioLogado(payload);

      if (userData.value.dataNascimento) {
        dataNascimentoOriginal.value = userData.value.dataNascimento;
      }

      texto.value = "Perfil atualizado com sucesso!";
      sucesso.value = true;
      aviso.value = true;
    }
  } catch (error) {
    console.error("Erro ao salvar:", error);
    texto.value = "Ocorreu um erro ao salvar. Tente novamente.";
    sucesso.value = false;
    aviso.value = true;
  } finally {
    modoEditar.value = false;
  }
}

function removerImagem() {
  imagemPreview.value = null;
  imagemBase64.value = null;
  imagemMimeType.value = null;
  userData.value.imagemUrl = null;
  userData.value.imagem = null;
  if (inputImagem.value) inputImagem.value.value = "";
}

async function mudarEmail() {
  await usuariosService.alterarEmail(novoEmail.value);

  texto.value =
    "Uma mensagem de confirmação foi enviada ao novo e-mail. Confirme para concluir a alteração.";
  sucesso.value = true;
  aviso.value = true;
  toggleMudarEmail.value = false;
}

function mudarSenha() {
  router.push("/recuperar-senha-perfil");
}

function abrirAcao(acaoId) {
  router.push(`acao/${acaoId}`);
}

onMounted(async () => {
  document.addEventListener("click", fecharMenuEmail);
  carregando.value = true;
  await coletarInformacoes();
  await carregarTermosUsuario();
  await coletarAcoesVinculadas();
  carregando.value = false;
});

onBeforeUnmount(() => {
  document.removeEventListener("click", fecharMenuEmail);
});
</script>

<style scoped>
#perfil-containder {
  background: var(--branco);
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

}

.perfil-body {
  width: 80%;
}


.perfil-header {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 2rem;
}

#edicao-credenciais {
  width: 100%;
  display: flex;
  gap: 20px;
  margin-bottom: 0rem;
}

.modal-corpo {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 5rem;
  background: var(--branco);

}

.modal-email {
  display: flex;
  width: 400px;
  border-radius: 12px;
  overflow: hidden;
  flex-direction: column;
}

.btn-editar-credencial {
  padding: 0.55rem 2.5rem;
  background-color: var(--roxo-primario);
  color: var(--branco);
  border: none;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.mb-3 {
  margin-bottom: 0 !important;

}

.btn-editar-credencial:hover {
  background-color: var(--roxo-medio);
  color: var(--branco);
  transition: 300ms;
}

/* ── Imagem de perfil ── */
.img-perfil {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 154px;
  height: 154px;
  flex-shrink: 0;
}

.img-perfil img {
  width: 154px;
  height: 154px;
  border-radius: 50%;
  object-fit: cover;
}

.img-perfil.editavel {
  cursor: pointer;
}

.img-perfil.editavel img {
  transition: filter 0.2s;
}

.img-perfil.editavel:hover img {
  filter: brightness(0.75);
}

.icone-editar-foto {
  position: absolute;
  bottom: 15px;
  right: 5px;
  background: var(--roxo-claro);
  color: var(--branco);
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 6px hsla(0, 0%, 0%, 0.25);
  pointer-events: none;
}

.btn-confirmar {
  background: var(--roxo-primario);
  color: var(--branco);
  border: none;
  border-radius: 10px;
  padding: 8px 24px;
  font-weight: 600;
  height: 44.3px;
  cursor: pointer;
  font-size: 0.9rem !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-confirmar:hover {
  background: var(--roxo-medio) !important;
}

.nome {
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: 1rem;
}

.nome-email h2 {
  font-size: 1.6rem;
  font-weight: 500;
  color: var(--preto);
  margin-bottom: 0rem !important;
}

.nome-email p {
  font-size: 0.88rem;
  color: var(--cinza-escuro);
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.nacionalidade p {
  font-size: 0.78rem;
  font-weight: 700;
  margin-bottom: 0 !important;
  color: var(--cinza-medio);
  text-transform: uppercase;
}

.informacoes-perfil {
  margin-bottom: 2rem;
}

.informacoes-perfil h3,
.acoes-perfil h3 {
  font-size: 0.9rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--preto);
  margin-bottom: 1.25rem;
}



.grid-acoes-perfil {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.conteudo {
  display: flex;
  flex-direction: row;
  box-shadow: none;
  background-color: transparent;
  border: 1px solid var(--cinza-medio);
  border-radius: 0.5rem;
  cursor: pointer;
  margin-bottom: 0;
  padding: 1rem;
  transition: transform 200ms, box-shadow 200ms, border-color 200ms;
  width: 100%;
  box-sizing: border-box;
  text-align: left;
  height: auto;
}

.conteudo:hover {
  transform: translateY(-2px);
  border-color: var(--roxo-claro);
  box-shadow:
    0 10px 24px -3px hsla(258, 53%, 28%, 0.14),
    0 4px 10px -2px hsla(258, 53%, 28%, 0.06);
}


.conteudo p {
  font-size: 15px;
  color: var(--preto);
  margin: 0;
}

.imagem-conteudo-acao {
  width: 260px;
  min-width: 260px;
  height: 170px;
  flex-shrink: 0;
  overflow: hidden;
  border-radius: 6px;
  background-color: var(--cinza-claro);
}

.imagem-conteudo-acao img {
  display: block;
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: 6px;
}

.conteudo-listagem-acao {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: left;
  padding: 0 0 0 20px;
  flex: 1;
  min-width: 0;
  gap: 16px;
}

.cima-conteudo-acao h5.titulo-acao {
  margin: 0 0 4px;
  font-size: 1.25rem;
  font-weight: 600;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.periodo-acao {
  display: block;
  font-size: 0.85rem;
  color: var(--cinza-escuro);
}


.area-tematica,
.funcao-membro {
  font-size: 0.9rem !important;
  color: var(--cinza-escuro);
  line-height: 1.5;
}

.baixo-conteudo-acao {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.sem-acoes {
  padding: 20px;
  background: var(--branco);
  border-radius: 8px;
  text-align: center;
  color: var(--cinza-escuro);
}

.sem-acoes p {
  font-size: 1rem;
  font-weight: 500;
  margin: 0;
}

.campos-infos {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.6rem 1.5rem;
  padding: 0 1rem;
}

.form-label {
  font-size: 1rem;
  color: var(--roxo-primario);
  margin-bottom: 0rem !important;
  display: block;
}

.form-control {
  width: 100%;
  padding: 0.55rem 0.85rem;
  border: 1.5px solid var(--roxo-claro);
  border-radius: 8px;
  background-color: var(--cinza-claro);
  color: var(--preto);
  font-size: 1rem;
  font-family: inherit;
  outline: none;
  transition:
    border-color 0.2s,
    background-color 0.2s;
}

.form-control:disabled {
  opacity: 1;
  cursor: default;
  background-color: var(--branco);
  border: none;
  padding: 0 !important;
  padding-left: 0.5rem !important;

}

.form-control:not(:disabled) {
  background-color: var(--branco);
  border: 1px solid var(--roxo-claro) !important;
  cursor: auto;
}

.form-control:not(:disabled):focus {
  border-color: var(--roxo-medio);
  box-shadow: 0 0 0 3px hsla(258, 70%, 58%, 0.15);
}

input[type="date"]:disabled {
  color: var(--preto);
  -webkit-text-fill-color: var(--preto);
  background-color: var(--branco);
  padding: 0 !important;
  padding-left: 0.5rem !important;
  border: none;
}

select.form-control {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}



select.form-control:not(:disabled) {
  -webkit-appearance: auto;

  -moz-appearance: auto;
  appearance: auto;
  cursor: pointer;

}

select.form-control:disabled {
  background-color: var(--branco);
  padding: 0 !important;
  padding-left: 0.5rem !important;
  border: none !important;
  color: var(--preto);
  opacity: 1 !important;
}

/* Validação */
.input-invalido {
  border-color: var(--vermelho) !important;
  background-color: var(--vermelho-claro) !important;
}

.msg-erro {
  display: block;
  margin-top: 0.25rem;
  font-size: 0.75rem;
  color: var(--vermelho);
}

/* Minhas Ações */
.acoes-perfil {
  margin-bottom: 2rem;
}

.acoes-vinculadas {
  display: flex;
  flex-direction: column;

}


.acao-card {
  border: 1px solid var(--cinza-medio);
  border-radius: 8px;
  background-color: var(--branco);
  padding: 1rem;
  margin-top: 1rem;
  gap: 1rem;
  font-size: 0.88rem;
  display: flex;
  color: var(--preto);
  line-height: 1.7;
  cursor: pointer;
  transition:
    transform 0.3s,
    box-shadow 0.3s;
}

.acao-card:hover {
  transform: translateY(-2px);
  border-color: var(--roxo-claro);
  box-shadow: 0 10px 24px -3px hsla(258, 53%, 28%, 0.14), 0 4px 10px -2px hsla(258, 53%, 28%, 0.06);
}

.acao-img {
  width: 150px;
  height: 150px;
  flex-shrink: 0;
  overflow: hidden;
  border-radius: 8px;
  background-color: var(--cinza-claro);
}

.acao-img img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: inherit;
}

.imagem-indisponivel {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: var(--cinza-escuro);
  font-size: 0.85rem;
}

.acao-card-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.acao-card-info span {
  font-weight: 600;
  color: var(--roxo-primario);

}

.acao-card-info p {
  margin-top: 0rem !important;
  margin-bottom: 0rem !important;
  color: var(--preto);

}

/* Botões */
.acoes-botoes {
  display: flex;
  justify-content: center;
  gap: 20px;


}

.btn-editar,
.btn-salvar {
  padding: 0.55rem 2.5rem;
  background-color: var(--roxo-primario);
  color: var(--branco);
  border: none;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-editar:hover,
.btn-salvar:hover {
  background-color: var(--roxo-medio);
}

.btn-cancelar {
  padding: 0.55rem 2.5rem;
  background-color: var(--branco);
  color: var(--roxo-claro);
  border: 1.5px solid var(--roxo-claro);
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-cancelar:hover {
  background-color: var(--roxo-superficie);
}

.btn-remover-foto {
  position: absolute;
  bottom: -15px;
  background: var(--vermelho);
  color: var(--branco);
  border: none;
  border-radius: 6px;
  width: auto;
  height: 26px;
  padding: 0 7px;
  font-size: 0.7rem;
  font-weight: bold;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 6px hsla(0, 0%, 0%, 0.25);
  transition: background-color 0.2s;
  z-index: 2;
}

.btn-remover-foto:hover {
  background-color: var(--vermelho);
}

.campos-form-container {
  width: 90%;
  height: auto;
}

.form {
  width: min(500px, 100%);
  min-height: 0;
  height: auto;
}

#voltar {
  width: min(500px, 100%);
}

.solicitacao-cadastral {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  padding: 0.5rem;
  margin-bottom: 2rem;
  border-radius: 12px;
  background-color: var(--branco);
}

.solicitacao-cadastral-info {
  display: flex;
  align-items: flex-start;
  gap: 0.85rem;
}

.solicitacao-cadastral-info>i {
  color: var(--roxo-primario);
  font-size: 1.5rem;
  flex-shrink: 0;
}

.solicitacao-cadastral-info h4 {
  margin: 0 0 0.4rem;
  color: var(--preto);
  font-size: 1rem;
  font-weight: 700;
}

.solicitacao-cadastral-info p {
  margin: 0;
  color: var(--cinza-escuro);
  font-size: 0.875rem;
  line-height: 1.5;
}

.menu-email {
  position: relative;
  flex-shrink: 0;
}

.menu-email-opcoes {
  position: absolute;
  top: calc(100% + 0.5rem);
  right: 0;
  min-width: 100%;
  margin: 0;
  padding: 0.35rem;
  list-style: none;
  background-color: var(--branco);
  border: 1px solid var(--roxo-claro);
  border-radius: 8px;
  box-shadow: 0 10px 24px -3px hsla(258, 53%, 28%, 0.14);
  z-index: 10;
}

.menu-email-opcoes a {
  display: block;
  padding: 0.6rem 0.85rem;
  border-radius: 6px;
  color: var(--preto);
  font-size: 0.875rem;
  text-decoration: none;
  white-space: nowrap;
}

.menu-email-opcoes a:hover {
  background-color: var(--roxo-superficie);
}

.btn-solicitar-alteracao {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border: none;
  cursor: pointer;
  font-family: inherit;
  flex-shrink: 0;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  background-color: var(--roxo-primario);
  color: var(--branco);
  font-size: 0.875rem;
  font-weight: 600;
  text-decoration: none;
  transition: background-color 0.2s;
}

.btn-solicitar-alteracao:hover {
  background-color: var(--roxo-medio);
  color: var(--branco);
}

/* Documentos e Condições de Uso (LGPD) */
.documentos-condicoes-perfil {
  margin-bottom: 2rem;
}

.documentos-condicoes-perfil h3 {
  font-size: 0.9rem;
  font-weight: 800;
  text-transform: uppercase;
  color: var(--roxo-escuro);
  letter-spacing: 0.5px;
  margin-bottom: 1rem;
}

.docs-condicoes-card {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.doc-item-linha {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
}

.doc-item-dados {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.doc-icone-svg {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background-color: transparent;
  color: #1f2937;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.doc-item-textos h4 {
  font-size: 0.98rem;
  font-weight: 600;
  color: #111827;
  margin: 0 0 0.15rem 0;
}

.doc-item-textos p {
  font-size: 0.85rem;
  color: #4b5563;
  margin: 0;
}

.link-consultar-doc {
  font-size: 0.9rem;
  font-weight: 500;
  color: #111827;
  text-decoration: underline;
  white-space: nowrap;
  cursor: pointer;
  transition: color 0.15s ease;
}

.link-consultar-doc:hover:not(.disabled) {
  color: var(--roxo-medio);
}

.link-consultar-doc.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  text-decoration: none;
}



.concordancia-secao {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.concordancia-subtitulo {
  font-size: 0.98rem;
  font-weight: 600;
  color: #111827;
  margin: 0;
}

.versao-rotulo {
  font-size: 0.82rem;
  color: #6b7280;
  margin-bottom: 0.25rem;
}

.concordancia-linha-status {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
}

.concordancia-descricoes {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.concordancia-declaracao {
  font-size: 0.95rem;
  font-weight: 600;
  color: #111827;
  margin: 0;
}

.concordancia-aviso {
  font-size: 0.85rem;
  color: #4b5563;
  margin: 0;
}

.concordancia-registro-data {
  font-size: 0.78rem;
  color: #9ca3af;
  margin-top: 0.25rem;
}

.concordancia-acao-status {
  flex-shrink: 0;
}

/* Checkbox customizado para concordância no perfil */
.custom-checkbox-perfil {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
  width: 26px;
  height: 26px;
  margin: 0;
}

.custom-checkbox-perfil input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark-perfil {
  width: 24px;
  height: 24px;
  background-color: var(--branco);
  border: 2px solid #9ca3af;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  position: relative;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.custom-checkbox-perfil:hover input:not(:disabled)~.checkmark-perfil {
  border-color: var(--roxo-primario);
}

.custom-checkbox-perfil input:checked~.checkmark-perfil {
  background-color: var(--roxo-primario);
  border-color: var(--roxo-primario);
}

.checkmark-perfil:after {
  content: "";
  position: absolute;
  display: none;
  left: 7px;
  top: 3px;
  width: 6px;
  height: 12px;
  border: solid white;
  border-width: 0 2.5px 2.5px 0;
  transform: rotate(45deg);
}

.custom-checkbox-perfil input:checked~.checkmark-perfil:after {
  display: block;
}

.custom-checkbox-perfil input:disabled~.checkmark-perfil {
  opacity: 0.6;
  cursor: not-allowed;
}

.spinner-checkbox-perfil {
  width: 14px;
  height: 14px;
  border-width: 2px;
  color: var(--roxo-primario);
}

.custom-checkbox-perfil input:checked~.checkmark-perfil .spinner-checkbox-perfil {
  color: var(--branco);
}

/* Modal de confirmação ao desmarcar termos */
.modal-confirmacao-termo {
  display: flex;
  flex-direction: column;
  width: 480px;
  max-width: 92vw;
  background-color: var(--branco);
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.15), 0 10px 10px -5px rgba(0, 0, 0, 0.08);
  animation: modal-fade-in 0.2s ease-out;
}

@keyframes modal-fade-in {
  from {
    opacity: 0;
    transform: scale(0.96);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

.modal-corpo-aviso-termo {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 1.75rem 1.5rem 1.25rem 1.5rem;
  text-align: center;
}

.icone-alerta-termo {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background-color: #fef3c7;
  color: #d97706;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.texto-aviso-desmarcar {
  font-size: 0.95rem;
  color: #374151;
  line-height: 1.55;
  margin: 0;
}

.texto-aviso-desmarcar strong {
  color: #b45309;
  font-weight: 700;
}

.modal-rodape-termo {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1.5rem 1.25rem 1.5rem;
  border-top: 1px solid #e5e7eb;
  background-color: #f9fafb;
}

.btn-cancelar-termo {
  padding: 0.55rem 1.25rem;
  background-color: var(--branco);
  color: #4b5563;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-cancelar-termo:hover:not(:disabled) {
  background-color: #f3f4f6;
  color: #111827;
}

.btn-continuar-sem-aceitar {
  padding: 0.55rem 1.25rem;
  background-color: var(--vermelho);
  color: var(--branco);
  border: 1px solid var(--vermelho);
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
}

.btn-continuar-sem-aceitar:hover:not(:disabled) {
  background-color: var(--vermelho-escuro);
  border-color: var(--vermelho-escuro);
}

.btn-continuar-sem-aceitar:disabled,
.btn-cancelar-termo:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 576px) {
  .modal-rodape-termo {
    flex-direction: column-reverse;
    gap: 0.5rem;
  }

  .btn-cancelar-termo,
  .btn-continuar-sem-aceitar {
    width: 100%;
    justify-content: center;
  }

}


@media (max-width: 768px) {
  #perfil-containder {
    margin: 0rem;
    padding: 0rem;
  }



  .campos-infos {
    grid-template-columns: 1fr;
    padding: 0;
  }

  .solicitacao-cadastral {
    flex-direction: column;
    align-items: stretch;
  }

  .btn-solicitar-alteracao {
    width: 100%;
    box-sizing: border-box;
  }

  .menu-email {
    width: 100%;
  }

  .menu-email-opcoes {
    left: 0;
    right: 0;
  }

  .grid-acoes-perfil {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(min(100%, 260px), 1fr));
    gap: 16px;
  }

  .conteudo {
    flex-direction: column;
    padding: 0;
    gap: 0;
    height: 100%;
    overflow: hidden;
  }

  .conteudo:hover,
  .conteudo:focus-visible {
    transform: none;
  }

  .imagem-conteudo-acao {
    width: 100%;
    min-width: 100%;
    height: 160px;
    border-radius: 0px;

  }

  .imagem-conteudo-acao img {
    border-radius: 0px;
  }

  .conteudo-listagem-acao {
    width: 100%;
    padding: 8px;
    flex: 1;
    gap: 16px;
  }

  .cima-conteudo-acao h5.titulo-acao {
    font-size: 1.1rem;
    margin-bottom: 6px;
  }

  .periodo-acao {
    font-size: 0.8rem;
  }

  .area-tematica,
  .funcao-membro {
    font-size: 13px !important;
  }

  .perfil-header {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .perfil-body {
    width: 100%;
  }

  .btn-editar-credencial {
    font-size: 0.7rem;
    padding: 0.5rem 0.7rem;
  }

  .btn-editar {
    font-size: 0.7rem;
    padding: 0.5rem 0.7rem;

  }

  .btn-cancelar,
  .btn-salvar {
    font-size: 0.7rem;
    padding: 0.5rem 0.7rem;

  }

  .nome {
    flex-direction: column;
    text-align: center;
    gap: 0.5rem;
    width: 100%;
    padding-top: 0;
  }

  #edicao-credenciais {
    width: 100%;
    justify-content: center;

  }

  .documentos-condicoes-perfil {
    width: 100%;
    margin-bottom: 1.5rem;
  }

  .docs-condicoes-card {
    gap: 1rem;
  }


  .doc-item-linha {
    flex-direction: column;

    justify-content: flex-start;
    gap: 0.3rem;
  }

  .doc-item-dados {
    width: 100%;
    gap: 0.65rem;
  }

  .doc-icone-svg {
    width: 36px;
    height: 36px;
  }

  .doc-item-textos h4 {
    font-size: 0.9rem;
    line-height: 1.35;
  }

  .doc-item-textos p {
    font-size: 0.8rem;
    line-height: 1.45;
  }

  .link-consultar-doc {
    align-self: flex-start;
    margin-left: 44px;
    white-space: normal;
    font-size: 0.82rem;
    line-height: 1.4;
  }

  .concordancia-secao {
    gap: 0.45rem;
  }

  .concordancia-subtitulo {
    font-size: 0.92rem;
    line-height: 1.4;
  }

  .concordancia-linha-status {
    align-items: flex-start;
    gap: 0.75rem;
  }

  .concordancia-declaracao {
    font-size: 0.87rem;
    line-height: 1.4;
  }

  .concordancia-aviso {
    font-size: 0.8rem;
    line-height: 1.45;
  }

  .concordancia-registro-data {
    font-size: 0.73rem;
    line-height: 1.4;
  }
}
</style>
